<h1 mat-dialog-title>Óraállás újraszámolása</h1>
<div mat-dialog-content>
  <mat-form-field class="w-100">
    <mat-label>Dátum</mat-label>
    <input matInput [matDatepicker]="picker" placeholder="Date" name="date" [(ngModel)]="item.date" required>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <div class="row">
    <div class="col-md-6">
      <mat-form-field class="w-100">
        <mat-label>Hour</mat-label>
        <mat-select [(ngModel)]="item.hour" name="hour" required >
          @for (h of hours; track h) {
            <mat-option [value]="h">{{h}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field class="w-100">
        <mat-label>Minute</mat-label>
        <mat-select [(ngModel)]="item.minute" name="minute" required>
          @for (m of minutes; track m) {
            <mat-option [value]="m">{{m}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <mat-form-field class="w-100 mb-2">
    <mat-label>Kezdő óraállás</mat-label>
    <input matInput type="number" placeholder="Value" name="value" [(ngModel)]="item.value" required>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Bezár</button>
  <button mat-button color="primary" (click)="onSaveClick()" translate>SAVE</button>
</div>
